function lazy(name) {
    return () => import('@/mobile/' + name)
}
const router = [
    {
        path: '/index_mb',
        name: 'index_mb',
        component: lazy('mb.vue'),
        redirect: '/mb',
        children: [
            {
                path: '/mb',
                component: lazy('index_mb.vue')
            },
            { path: "/companyprofile/introduction_mb", component: lazy('companyprofile/introduction_mb') },
            { path: "/dynamicstate/news_mb", component: lazy('dynamicstate/news_mb') },
            { path: "/specialtyinstruction/project_mb", component: lazy('specialtyinstruction/project_mb') },
            { path: "/ours/recruitment_mb", component: lazy('ours/recruitment_mb') },
            { path: "/feedback/questionnaire_mb", component: lazy('feedback/questionnaire_mb') },
            { path: "/relation_mb", component: lazy('relation_mb') }
        ]
    }
]
export default router


// WEBPACK FOOTER //
// ./src/router/mobile.js